import React from 'react';

interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  return <View>unknown.tsx - {JSON.stringify(model)}</View>;
};
